import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Observation } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import ObservationsSectionTableRow from './ObservationsSectionTableRow';
import { useObservationsSection } from '../context/ObservationsSectionContext';

const ObservationsSectionTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useObservationsSection();

  const hasData = data.observations?.length > 0;

  const rows = data.observations!.map(
    (observation: Observation, index: number) => (
      <ObservationsSectionTableRow
        key={observation._id ?? `observation-row-${index}`}
        index={index}
        observation={observation}
      />
    )
  );

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoObservations')}
    />
  );
};

export default ObservationsSectionTableBody;
